import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const STATUS_ROT = { aguardando_questionario: "Aguardando seu questionário", aguardando_evidencias: "Aguardando evidências",
  aguardando_avaliacao_humana: "Em análise pela equipe", aguardando_complemento: "Aguardando complemento", avaliada: "Análise concluída", encerrada: "Encerrada" };

// Portal do cliente — Avaliação Pós-Montagem por link seguro (token). Nunca mostra percentuais/score/hipótese.
export default function ClienteAvaliacao() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [resp, setResp] = useState({});
  const [relato, setRelato] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API}/cliente/avaliacao/${token}`).then((r) => { setD(r.data); setRelato(r.data.avaliacao.relato_cliente || ""); setResp(r.data.avaliacao.respostas_questionario || {}); })
    .catch(() => setD({ erro: true }));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return <div className="p-8 text-sm">Carregando…</div>;
  if (d.erro) return <div className="p-8 text-sm" data-testid="cliente-aval-erro">Link inválido ou expirado.</div>;
  const av = d.avaliacao;
  const aberta = !["avaliada", "encerrada"].includes(av.status);
  const perguntas = d.questionario.filter((q) => !q.condicao || Object.entries(q.condicao).every(([k, v]) => resp[k] === v));
  const enviar = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await axios.post(`${API}/cliente/avaliacao/${token}/questionario`, { respostas: resp, relato_cliente: relato });
      toast.success("Questionário enviado. Nossa equipe fará a análise e retornará em breve.");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Falha ao enviar"); }
    setBusy(false);
  };
  const upload = async (tipo, file) => {
    const fd = new FormData(); fd.append("file", file); fd.append("tipo", tipo);
    try { await axios.post(`${API}/cliente/avaliacao/${token}/evidencias`, fd); toast.success("Arquivo enviado"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Falha no envio"); }
  };
  return (
    <div className="max-w-2xl mx-auto p-6" data-testid="cliente-avaliacao">
      <div className="text-xs font-bold uppercase tracking-wider text-[#B45309]">Reclamação pós-montagem</div>
      <h1 className="font-heading font-extrabold text-2xl mt-1">{av.produto}</h1>
      <div className="text-sm text-[#334155]">Pedido {av.pim_code} · Situação: <b data-testid="cliente-aval-status">{STATUS_ROT[av.status] || av.status}</b></div>
      <div className="text-xs text-[#64748B] mt-1">Recebemos sua reclamação em {new Date(av.data_reclamacao).toLocaleDateString("pt-BR")}. Nossa equipe analisará as informações e evidências e retornará em breve.</div>

      {aberta && (
        <div className="mt-6 border border-[#E2E8F0] bg-white p-5" data-testid="cliente-aval-form">
          <div className="text-xs font-bold uppercase tracking-wider mb-3">Conte-nos o que aconteceu</div>
          <label className="text-xs">Relato</label>
          <textarea className="w-full border border-[#E2E8F0] p-2 text-sm mb-3" rows={3} value={relato} onChange={(e) => setRelato(e.target.value)} data-testid="cliente-aval-relato" />
          {perguntas.map((q) => (
            <div key={q.chave} className="mb-3 text-sm">
              <div className="font-medium">{q.pergunta}</div>
              {q.tipo === "texto" ? <input className="w-full border border-[#E2E8F0] p-2 text-sm" value={resp[q.chave] || ""} onChange={(e) => setResp({ ...resp, [q.chave]: e.target.value })} data-testid={`cq-${q.chave}`} /> : (
                <select className="w-full border border-[#E2E8F0] p-2 text-sm bg-white" value={resp[q.chave] || ""} onChange={(e) => setResp({ ...resp, [q.chave]: e.target.value })} data-testid={`cq-${q.chave}`}>
                  <option value="">Selecione…</option>{q.opcoes.map((o) => <option key={o} value={o}>{o.replaceAll("_", " ")}</option>)}
                </select>)}
            </div>
          ))}
          <Button onClick={enviar} disabled={busy} className="w-full h-11 bg-[#FF6700] hover:bg-[#e65d00] text-white font-bold" data-testid="cliente-aval-enviar">Enviar questionário</Button>
          <div className="mt-5 text-xs font-bold uppercase tracking-wider">Evidências adicionais</div>
          <div className="text-[11px] text-[#64748B] italic mb-2">{d.orientacao_video}</div>
          <div className="flex flex-wrap gap-2">{Object.entries(d.evidencias).map(([t, obrig]) => (
            <label key={t} className="text-[11px] border border-[#E2E8F0] px-2 py-1 cursor-pointer" data-testid={`cliente-ev-${t}`}>{t.replaceAll("_", " ")}{obrig && "*"}<input type="file" className="hidden" accept={t === "video" ? "video/*" : "image/*"} onChange={(e) => e.target.files[0] && upload(t, e.target.files[0])} /></label>
          ))}</div>
          <div className="text-[11px] text-[#64748B] mt-2">Fotos enviadas: {(av.fotos || []).length} · Vídeo: {av.video ? "✔" : "—"}</div>
        </div>
      )}
      {!aberta && (
        <div className="mt-6 border border-[#E2E8F0] bg-white p-5 text-sm" data-testid="cliente-aval-concluida">
          Sua solicitação foi analisada. {av.destino_operacional ? "A loja entrará em contato com os próximos passos." : ""}
        </div>
      )}
    </div>
  );
}
